(function ($, undefined) {
    "use strict"

    $.extend($.fn.tokenInput.options, {
        locale: "hu",
        trans: {
            searchInputPlaceholder: "Keresendő kifejezés...",
            noEnoughDataForSearch: "A keresendő kifejezés nem elégendő hosszúságú a keresés indításához.",
            searchInProgress: "Keresés...",
            resultIsEmpty: "Nincs megfelelő találat.",
            ajaxError: "Hiba történt a keresés során."
        }
    })
}(jQuery))



//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/js-tokeninput/js/hu.js
// module id = 328
// module chunks = 0